import React from 'react'

export default function ResultBox({ label, icon, value, highlightClass = '' }) {
  return (
    <div className="result-box">
      <p className="result-label">
        {icon}
        {label}
      </p>
      <p className={`result-value ${highlightClass}`}>{value}</p>
    </div>
  )
}
